import type { DragEvent } from "react";
import { GripVertical, Plus } from "lucide-react";
import { Button } from "@/shared/components/shadcn/Button";
import type { FieldWidget } from "@froppio/form-core";
import type { BuilderDragSource } from "../types/builderDragTypes";
import { fieldWidgets } from "@froppio/form-core";

interface BuilderPaletteProps {
  onAdd: (widget: FieldWidget | "section") => void;
  onDragStart: (event: DragEvent<HTMLElement>, source: BuilderDragSource) => void;
  onDragEnd: () => void;
}

export function BuilderPalette({ onAdd, onDragStart, onDragEnd }: BuilderPaletteProps) {
  return (
    <aside aria-label="Field palette" className="space-y-4 rounded-[20px] border border-border bg-card p-4">
      <div>
        <h2 className="text-base font-bold">Add content</h2>
        <p className="mt-1 text-xs text-muted-foreground">Drag onto the form, or click to add to the selected section.</p>
      </div>
      <div className="space-y-2">
        {fieldWidgets.map(({ widget, label }) => (
          <Button key={widget} variant="outline" className="w-full justify-start text-left" draggable
            onDragStart={event => onDragStart(event, { type: "palette", widget })} onDragEnd={onDragEnd}
            onClick={() => onAdd(widget)} aria-label={`Add ${label.toLowerCase()}`}>
            <GripVertical aria-hidden="true" className="text-muted-foreground" />{label}
          </Button>
        ))}
        <Button variant="secondary" className="w-full justify-start" draggable
          onDragStart={event => onDragStart(event, { type: "palette", widget: "section" })} onDragEnd={onDragEnd}
          onClick={() => onAdd("section")} aria-label="Add section">
          <Plus aria-hidden="true" />Section
        </Button>
      </div>
    </aside>
  );
}
